var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container is-fluid"},[(_vm.requiredRegistration)?_c('div',[_c('profile-setup',{attrs:{"newUserId":_vm.newUserId}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }